// extracted by mini-css-extract-plugin
export default {"content-wrapper":"GeneralStyles_content-wrapper__W3GY6","title":"GeneralStyles_title__pxhz+","subtitle":"GeneralStyles_subtitle__i3Ebx"};